import React, { useEffect, useState } from "react";
import { SupportProductItemModel } from "./SupportProductItemModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

import "./SupportProductItem.css";
import Utils from "../../core/Utils/Utils";

interface SupportProductItemProps {
  blok: SupportProductItemModel;
  handleSupportItemClick?: () => void;
  handleGettingStartedItemClick?: () => void;
}

const SupportProductItem: React.FC<SupportProductItemProps> = ({
  blok,
  handleSupportItemClick,
  handleGettingStartedItemClick,
}) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const handleSupportClick = () => {
    if (handleSupportItemClick) {
      handleSupportItemClick();
    }
  };

  const handleGettingStartedClick = () => {
    if (handleGettingStartedItemClick) {
      handleGettingStartedItemClick();
    }
  };

  const handleUserGuideClick = () => {
    const url = new URL(blok.userGuide.cached_url, window.location.origin);
    window.open(url.href, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className="support-product-item"
      style={{ backgroundColor: blok.backgroundColor }}
    >
      <div className="support-product-item-image">
        <img
          src={Utils.getCacheUrl(blok.image?.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image?.filename)}
        />
      </div>
      <div className="support-product-item-title">{blok.title}</div>
      <div className="support-product-item-description">{blok.description}</div>
      <div className="support-product-item-action">
        <span
          onClick={handleSupportClick}
          style={{ color: theme?.hyperlinksColor }}
        >
          Support
        </span>
        <span
          onClick={handleGettingStartedClick}
          style={{ color: theme?.hyperlinksColor }}
        >
          Getting started
        </span>
        <span
          onClick={handleUserGuideClick}
          style={{ color: theme?.hyperlinksColor }}
        >
          User guide
        </span>
      </div>
    </div>
  );
};

export default SupportProductItem;
